<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-6">
    <pr-input-column
      label="Nom du notaire"
      [derrors]="derrors"
      [isDefault]="false"
    >
      <input
        formControlName="avClauseBeneficiaireNomNotaire"
        type="text"
        placeholder="Exemple : Bernardin"
      />
    </pr-input-column>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-6">
    <pr-input-column
      label="Prénom du notaire"
      [derrors]="derrors"
      [isDefault]="false"
    >
      <input
        formControlName="avClauseBeneficiairePrenomNotaire"
        type="text"
        placeholder="Exemple : Yves"
      />
    </pr-input-column>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-12">
    <pr-input-map
      (placeChanged)="toValue = $event"
      placeholder="Enter to address..."
      label="Saisissez l’adresse du notaire"
      formGroupName="avClauseBeneficiaireAddresseNotaire"
      [isGMaps]="true"
      [countries]="countries"
      [derrors]="derrors"
      [isDefault]="false"
    >
    </pr-input-map>
  </div>
</div>
